/**
 * AI.GEN lines=1-19
 * 页面加载中组件
 */
import React from 'react';
import { Spin } from 'antd';

export const LayoutLoading = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%', // 页面级 loading 建议设定高度
        backgroundColor: '#fff',
      }}
    >
      <Spin size="default" />
    </div>
  );
};
